/**
 * Event data use case
 * Application layer service for managing event data operations
 */

import { eventApiClient } from '../infrastructure/ApiClient.js'
import { loadGpxRoute } from '../utils/gpxUtils.js'

/**
 * Event data service
 */
export class EventDataService {
  /**
   * Get complete event data including route and markers
   * @param {string} eventAlias - Event alias
   * @returns {Promise<Object>} Complete event data
   */
  async getEventData(eventAlias) {
    const eventData = await eventApiClient.getEventData(eventAlias)
    
    // Load GPX route if available
    let eventRoute = []
    if (eventData.routeUrl) {
      eventRoute = await loadGpxRoute(eventData.routeUrl)
    }
    
    return {
      markers: eventData.markers || [],
      route: eventRoute,
      eventInfo: eventData
    }
  }

  /**
   * Create mock event data for development
   * @returns {Object} Mock event data
   */
  createMockEventData() {
    return {
      markers: [
        {
          id: 1,
          text: 'START',
          type: 1,
          latitude: 50.7635,
          longitude: 16.2805,
          sort: 1
        },
        {
          id: 2,
          text: 'Punkt kontrolny 10km',
          type: 3,
          latitude: 50.7705,
          longitude: 16.2875,
          sort: 2
        },
        {
          id: 3,
          text: 'META',
          type: 2,
          latitude: 50.7785,
          longitude: 16.2955,
          sort: 3
        }
      ],
      route: [
        { latitude: 50.7600, longitude: 16.2800 },
        { latitude: 50.7800, longitude: 16.3000 },
        { latitude: 50.8000, longitude: 16.3200 },
        { latitude: 50.8200, longitude: 16.3400 },
        { latitude: 50.8400, longitude: 16.3600 },
        { latitude: 50.8600, longitude: 16.3800 },
        { latitude: 50.8800, longitude: 16.4000 },
        { latitude: 50.9000, longitude: 16.4200 }
      ],
      eventInfo: {
        name: 'Wydarzenie Demo',
        date: new Date().toISOString()
      }
    }
  }
}

// Export singleton instance
export const eventDataService = new EventDataService()